module.exports = __webpack_public_path__ + "media/src/images/appscho-e1bd9f1fd892378b547f78f7841ce4e6.png";